export default "__VITE_ASSET__BU6t$VNv__"